import React, { ReactNode } from "react";

export const SubNavbar = ({ children }: { children: ReactNode }) => (
  <div className="container-fluid">
    <div className="sub-navbar">{children}</div>
  </div>
);
